let DomainLocationSelector = function () {
    let init = () => {
        toggleLocationsPanelBody();
        removeDomainableAttributePanel();
        addDomainableAttributePanel();
    };

    let toggleLocationsPanelBody = () => {
        $('.panel-header-toggle').off('click').on('click', function () {
            $(this).closest('.panel').find('.panel-body').toggle();
        });
    };

    let removeDomainableAttributePanel = () => {
        $('.remove-domainable-attribute').off('click').on('click', function () {
            $(this).closest('.panel').remove();
        });
    };

    let addDomainableAttributePanel = () => {
        $('#add-domainable-attribute').on('click', function () {
            let lastKey = $('.domainable-attribute-panel').length ? $('.domainable-attribute-panel').last().data('key') : -1;
            let config = $(this).data('config').replaceAll('\\', '_');
            let route = '/domain_attributes/get_template/' + config + '/' + (lastKey + 1);

            $.get(route, (data) => {
                $('.domainable-attribute-panel').length
                    ? $('.domainable-attribute-panel').last().after(data)
                    : $('.domainable-attributes').append(data);

                $(data).find('.editor').each(function() {
                    CKEDITOR.replace( $(this).attr('id'), {
                        language: 'ru',
                        format: 'dd.mm.yyyy',
                        filebrowserBrowseUrl : '/elfinder/ckeditor',
                        filebrowserImageBrowseUrl : '/elfinder/ckeditor',
                        filebrowserUploadUrl : '/images/upload',
                        filebrowserImageUploadUrl : '/images/upload'
                    });
                });

                toggleLocationsPanelBody();
                removeDomainableAttributePanel();
            });
        });
    };

    return {
        init: init
    }
}();

export default DomainLocationSelector;
